/** translate-info: add info number based translations. currently only needed by datasheet */

import T from './translate.js';

import addDE from './translate-info--de.js';
import addEN from './translate-info--en.js';
import addFR from './translate-info--fr.js';

switch (T.lang) {
	case 'de':
		addDE(T.current);
		break;
	case 'fr':
		addFR(T.current);
		break;
	//case 'en':
	default:
		addEN(T.current);
		break;
}
